import React, { ReactNode } from "react";
import { Icon } from "../elements/Icons";

type GraphTabsWrapperPropsT = {
  children: ReactNode;
  tabsCount: number;
};
export const GraphTabWrapper = ({ children, tabsCount }: GraphTabsWrapperPropsT) => {
  return (
    <div className="tabs-dashboard ui-tabs ajax-tabs std-tabs ui-widget ui-widget-content ui-corner-all">
      <ul
        className={`list-columns-${tabsCount} ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all`}
        role="tablist"
        style={{ display: "flex" }}
      >
        {children}
      </ul>
    </div>
  );
};
export type GraphCompareDataT = {
  direction: GraphCompareDataDirectionT;
  percentageValue: string;
  value: string;
};

type GraphTabPropsT = {
  active?: boolean;
  additional?: string;
  compareData?: GraphCompareDataT | null;
  header?: string;
  invertArrowLogic?: boolean;
  main?: string;
  onClick: () => void;
};

export enum GraphCompareDataDirectionT {
  Negative = "negative",
  Positive = "positive",
}

export const GraphTab = ({
  active,
  additional,
  compareData,
  header,
  invertArrowLogic,
  main,
  onClick,
}: GraphTabPropsT) => {
  const isActive = active;

  const getColorClass = () => {
    if (!compareData) {
      return "";
    }
    const isNegative = compareData.direction === GraphCompareDataDirectionT.Negative;
    if (invertArrowLogic) {
      return isNegative ? "shoptet-icon-color-green icon-size-24" : "shoptet-icon-color-red icon-size-24";
    }
    return isNegative ? "shoptet-icon-color-red icon-size-24" : "shoptet-icon-color-green icon-size-24";
  };

  return (
    <li
      aria-controls="uitab-settings"
      aria-selected={isActive}
      className={`ui-state-default ui-corner-top ${isActive ? "ui-tabs-active ui-state-active" : ""}`}
      role="tab"
      style={{ flexGrow: 1 }}
      tabIndex={isActive ? -1 : 0}
    >
      <a
        className="ui-tabs-anchor"
        role="presentation"
        tabIndex={-1}
        style={{
          minHeight: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        {header && <span className="tab-content-header">{header}</span>}
        {main && <span className="tab-content-main">{main}</span>}
        {additional && <span className="tab-content-additional">{additional}</span>}
        {compareData && compareData?.value && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "6px" }}>
            <Icon
              className={getColorClass()}
              kind={compareData?.direction === GraphCompareDataDirectionT.Negative ? "shp-arrow-down" : "shp-arrow-up"}
            />
            <span className="ui-tabs__compare-values" style={{ marginLeft: "4px", color: "inherit", fontSize: "11px" }}>
              <span style={{ fontWeight: "700" }}>{compareData?.percentageValue} </span>
              <span>({compareData?.value})</span>
            </span>
          </div>
        )}
      </a>
    </li>
  );
};
